import React from "react";

const VariantRow = ({ variant, isSelected, isAlreadyAdded, onToggle }) => {
  const specLabel = variant.specification && variant.quantity_unit
    ? `${variant.specification} ${variant.quantity_unit}`
    : variant.specification || variant.quantity_unit || null;

  return (
    <label
      className={`flex items-start p-3 bg-white rounded-lg border cursor-pointer transition-colors ${
        isAlreadyAdded
          ? "opacity-50 cursor-not-allowed bg-gray-50"
          : isSelected
            ? "border-blue-400 bg-blue-50"
            : "hover:bg-gray-50 border-gray-200"
      }`}
    >
      <input
        type="checkbox"
        checked={isSelected}
        onChange={() => !isAlreadyAdded && onToggle(variant._id)}
        disabled={isAlreadyAdded}
        className="mt-0.5 mr-3 accent-blue-600 flex-shrink-0"
      />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-sm font-medium text-gray-800">{variant.variant_name}</span>
          {isAlreadyAdded && (
            <span className="text-xs bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded-full">
              Already Added
            </span>
          )}
        </div>
        <div className="flex flex-wrap gap-x-3 gap-y-0.5 mt-1">
          {specLabel && (
            <span className="text-xs text-gray-500">
              <span className="text-gray-400">Spec:</span> {specLabel}
            </span>
          )}
          {variant.sales_unit && (
            <span className="text-xs text-gray-500">
              <span className="text-gray-400">Unit:</span> {variant.sales_unit}
            </span>
          )}
          <span className="text-xs text-gray-500">
            <span className="text-gray-400">SKU:</span> {variant.sku_number || "N/A"}
          </span>
          {variant.barcode && (
            <span className="text-xs text-gray-500">
              <span className="text-gray-400">Barcode:</span> {variant.barcode}
            </span>
          )}
          {variant.mrp != null && variant.mrp > 0 && (
            <span className="text-xs text-gray-500">
              <span className="text-gray-400">MRP:</span> ₹{variant.mrp}
            </span>
          )}
        </div>
        {variant.attributes?.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mt-1.5">
            {variant.attributes.map((a, i) => (
              <span key={i} className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full">
                {a.attribute_name}: {a.value}
              </span>
            ))}
          </div>
        )}
      </div>
    </label>
  );
};

export default VariantRow;